import { render, staticRenderFns } from "./DriverStatus.vue?vue&type=template&id=22248bfa&scoped=true&"
import script from "./DriverStatus.vue?vue&type=script&lang=js&"
export * from "./DriverStatus.vue?vue&type=script&lang=js&"
import style0 from "./DriverStatus.vue?vue&type=style&index=0&id=22248bfa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22248bfa",
  null
  
)

export default component.exports